export default __webpack_public_path__ + "static/media/stereo_04.cf058b50.gif";